// extracted by mini-css-extract-plugin
module.exports = {"content":"Modal_keto_content__16_Aa","buttons":"Modal_keto_buttons__3ood5"};